module.exports = "fragment Country on CountryType{__typename id isoCode value:isoCode name label:name flagSquare phonePrefix}"